import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';

const styles = (theme) => ({
  footer: {
    padding: 15,
    height: '50px', //화면맞춤 때문에 높이 고정값으로 설정해놓음
    backgroundColor: '#000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    color: '#fff',
  },
});

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.footer} id="footer">
        Copyright © InnoN All Rights Reserved.
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(Footer));
